import { z } from 'zod';

export const VARIABLE_OPERATION_SCHEMA = z.union([
    z.literal('add'),
    z.literal('subtract'),
    z.literal('set'),
    z.literal('clear'),
]);
export type VariableOperation = z.infer<typeof VARIABLE_OPERATION_SCHEMA>;
